<template>
	<div>
		<div>
			<h2>新升通用编码规范 v2.7 </h2><br>
			&nbsp;&nbsp;本编码规范基于阿里巴巴、华为的开发手册，添加了新升团队的风格和规范，补充了一些细节。参训学员严格按照该开发规范开发，
以保证团队内风格统一，提高代码的可读性和可维护性。<br><br>

&nbsp;&nbsp;&nbsp;&nbsp; “任何卷入复杂事务的人都需要团队，团队中最重要就是遵守纪律”<br>
			<hr><br>
		</div>
		<div style="padding-left: 80px;">
			<ol>
				<li>
					<h3> 工程名全小写，变量名、方法名使用骆驼命名法，常量名大写</h3><br>
					<ul style="padding-left: 30px;">
						<li>尽量使用常用而且简单的英文单词，且单词正确</li>
						<li>尽量不要用汉语拼音（特殊情况除外，比如某些税务系统的特殊科目命名）</li>
						<li>单词要符合业务的“暗示”，用复数代表</li>
						<li>不要出现长得形似的长尾变量名,如：allocationWorkingHours和availableWorkingHours</li>
					</ul><br>
				</li>
				<li>
					<h3> 各个端、数据库、等命名要统一</h3><br>
					<ul style="padding-left: 30px;">
						<li>无论团队里的前端、后端、移动端、数据库、服务器、redis、docker等等一切对于 某个业务或者某个业务单元的命名必须高度保持一致</li><br>
					</ul>
				</li>
				 
				<li>
					<h3> 变量属性名前置</h3><br>
					如 订单数量:<br>
					let orderCount；<br>
					let ordersCount；<br>
					let orderCnt；<br>
					int ordersCnt；<br><br>
				</li>
				<li>
					<h3> 方法名应该是动词异或动名词，属性名后置</h3><br>
					如 比如创建订单方法:<br>
					createOrder<br>
					查询订单方法：<br>
					queryOrder<br><br>
				</li>

				<li>
					<h3> 方法名命名的约定</h3><br>
					查询前缀：<br>

					<ul style="padding-left: 30px;">
                                 <li>list代表取回一个集合</li>
					   如: listOrdersByName<br> 
					   <li>get代表取回一个对象</li>
					   如: getOrderByType<br>
					   <li>find/select/query代表动态查询条件</li>
					   <li>page表示是一个分页查询</li>
					</ul>
					<br>
					 
				</li>

				<li>
					<h3> 命名方法的介词</h3><br>

					<ul style="padding-left: 30px;">
                                 <li>by 以什么</li>
					   如： findByID(String id)<br> 
					   <li>at 当什么</li>
					   如： findAtDate(Date day)<br>
					   <li>in 包含什么</li>
					   <li>with 有什么</li>
					   <li>without 排除没带什么</li>
					</ul>
					<br>
					 
				</li>

				<li>
					<h3> 注释和代码一样重要</h3><br>
					注释除了说明作用、逻辑之外。还在当业务逻辑过于复杂，代码过于庞大的时候，注释就变成使逻辑思路变得清晰的路标。<br><br>
				</li>

				<li>
					<h3> 代码Git提交规范</h3><br>
					<ul style="padding-left: 30px;">
						<li>提交前先更新 pull 一次代码，提交前发生冲突要比提交后发生冲突容易解决的多</li>
						<li>切忌全部提交，只提交自己本次更新的文件</li>
						<li>尽量使用分支/合并进行代码开发，分支以自己的昵称+日期命名，合并后1个月后才可以删除分支</li>
						<li>提交前应该冷静、仔细检查一下，确保新增加的文件需要勾选加入版本控制</li>
						<li>提交前应该先编译一次保证能正确运行，防止出现编译都报错的情况</li>
						<li>提交时检查注释是否准确简洁的表达出了本次提交的内容。 如完成功能，注释为“新增 XX 功能”</li>
						<li>若此次提交代码对应scrum系统中的任务或者 bug，格式如下：</li><br>
						        task#[任务id] [任务标题] [具体事项]<br>
			                      bug#[bug id] [bug标题] [具体事项]<br><br>
						    <li>使用 git，必须添加 .gitignore 忽略配置文件。 不要提交与项目无关的内容文件：idea 配置、target 包、前端的dist文件夹、node_modules等</li>
					</ul>
				</li>
				<li>
					<h3> restful接口规范</h3><br>
					<ul style="padding-left: 30px;">
						<li>获取数据尽量使用get，提交数据使用post</li>
						<li>后端接口uri映射路径全部使用小写，命名与模块-类-功能保持一致，有较高的辨识度</li>
						<li>后端接口一定要有详细是注释，swagger 接口注释必须加上后端作者</li>
						<li>前端api接口以页面为单位，功能分类命名与后端保持高度一致</li>
					</ul>
				</li>
			</ol>

			<br>
		</div>
	</div>
</template>

<script>

export default {
	name: 'dev-common',
	data() {
		return {


		};
	},

	methods: {

	},
	mounted() {

	}
};
</script>

<style lang="scss" scoped="scoped"></style>
